<template>
  <v-container fluid style="background-color: white">
    <v-btn class="mb-4 bg-gradient-danger" dark @click="checkAllStudents">
      БҮХ СУРАЛЦАГЧИЙГ ШАЛГАХ
    </v-btn>

    <v-data-table
      :headers="headers"
      :items="$attrs.classStudents"
      class="elevation-1"
      hide-details
      hide-default-footer
      :items-per-page="-1"
    >
      <template v-slot:item.action="{ item }">
        <v-btn color="red" outlined small @click="checkStudent(item)">
          ШАЛГАХ
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        { text: "№", value: "index", sortable: false, width: "2%" },
        { text: "Суралцагч", value: "name" },
        { text: "Регистр", value: "REGISTER" },
        { text: "Үйлдэл", value: "action", sortable: false },
        { text: "Үйлдлийн огноо", value: "date" },
        { text: "Устгах", value: "delete", sortable: false },
      ],
      students: [
        { name: "С.Айгерим", register: "щц13281304", date: "-", delete: "-" },
        { name: "Г.Анан", register: "ме13231213", date: "-", delete: "-" },
        {
          name: "Б.Бат-Ирээдүй",
          register: "тю13271716",
          date: "-",
          delete: "-",
        },
        // Add the rest of your student data here
      ],
    };
  },
  methods: {
    checkStudent(student) {
      console.log("Checking student:", student.name);
      this.$swal.fire("Xугацаа нь болxоор нээгдэнэ!");
    },
    checkAllStudents() {
      this.$swal.fire("Xугацаа нь болxоор нээгдэнэ!");
    },
  },
};
</script>
